import { Component, ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { Button } from './ui/Button'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="min-h-[50vh] flex items-center justify-center p-6">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-full bg-error-50 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-8 h-8 text-error-500" />
            </div>
            <h2 className="text-lg font-semibold text-text-primary mb-2">
              Algo salio mal
            </h2>
            <p className="text-sm text-text-secondary mb-6">
              Ha ocurrido un error inesperado. Puedes intentar recargar la pagina o volver al inicio.
            </p>
            {this.state.error && (
              <details className="mb-6 text-left">
                <summary className="text-xs text-text-tertiary cursor-pointer">
                  Ver detalles del error
                </summary>
                <pre className="mt-2 p-3 bg-surface-0 border border-border rounded-lg text-xs text-error-500 overflow-auto">
                  {this.state.error.message}
                </pre>
              </details>
            )}
            <div className="flex items-center justify-center gap-3">
              <Button
                variant="secondary"
                onClick={() => window.location.href = '/'}
              >
                Volver al inicio
              </Button>
              <Button
                onClick={() => window.location.reload()}
              >
                <RefreshCw className="w-4 h-4 mr-1.5" />
                Recargar
              </Button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
